import { useMutation } from 'react-query';
import { request } from '../utility/axios-utils';
const logout = (accessToken) => {
  return request({
    url: '/logout',
    method: 'post',
    data: {},
    headers: { Authorization: `Bearer ${accessToken}` },
    withCredentials: true,
  });
};
export const useLogout = () => {
  return useMutation('logout', logout, {
    enabled: false,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
};
